<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      :loading="loading"
      hide-default-footer
      :items-per-page="24"
      class="elevation-1 text-overflow my-10"
      item-key="uuid"
      @click:row="previewItem"
    >
      <template v-slot:top>
        <v-toolbar flat height="70">
          <v-col cols="5" sm="3" md="3" lg="3" xl="2" class="pl-0">
            <v-row justify="start" class="ml-1">
              <v-toolbar-title class="headline" :data-cy="title">
                <span>
                  {{ title }}
                </span>
                <v-btn
                  v-if="canUseKnowledgeBaseBtn"
                  @click="handleHelp"
                  icon
                  color="primary"
                >
                  <v-icon>mdi-help-circle</v-icon>
                </v-btn>
              </v-toolbar-title>
            </v-row>
          </v-col>
        </v-toolbar>
      </template>

      <template v-slot:item.generated_by="{ item }">
        <span class="text--capitalize">{{
          item.generated_by.toLowerCase()
        }}</span>
      </template>
      <template v-slot:item.notes="{ item }">
        <span v-if="item.notes.length !== 0">{{ item.notes[0].content }}</span>
      </template>
      <template v-slot:item.title="{ item }">
        <span class="text--capitalize">{{ item.title.toLowerCase() }}</span>
      </template>
      <template v-slot:item.engine_hours="{ item }">
        <span v-if="item.engine_hours !== null">
          <span>{{ item.engine_hours }}</span>
        </span>
      </template>
      <template v-slot:item.completion_date="{ item }">
        <span v-if="item.completion_date !== null">
          <span>{{ $moment(item.completion_date).format("YYYY-MM-DD") }}</span>
        </span>
      </template>
    </v-data-table>
    <v-pagination
      v-model="currentPage"
      :length="numberOfPages"
      :total-visible="7"
      color="primary"
    />
    <help-dialog
      :dialog="helpDialog"
      @close="closeHelpDialog"
      v-if="helpDialog.active"
    ></help-dialog>
  </div>
</template>

<script>
import HelpDialog from "@/components/dialogs/HelpDialog";
import constraints from "@/utils/constraints";

export default {
  props: {
    title: String,
    headers: Array,
    data: Array,
    sort: String,
    loading: Boolean,
    response: Object,
  },

  components: {
    HelpDialog,
  },

  data: () => ({
    canUseKnowledgeBaseBtn: false,
    helpDialog: { location: null, active: false },
    query: {
      page: 1,
    },
  }),
  created() {
    this.canUseKnowledgeBaseBtn =
      constraints.canUseKnowledgeBaseBtn("services");

    this.query.page = 1;
  },

  computed: {
    formTitle() {
      return this.title.substring(0, this.title.length - 1);
    },
    numberOfPages() {
      if (!this.response) {
        return 0;
      }
      return parseInt(Math.ceil(this.response.count / 24));
    },
    currentPage: {
      get: function () {
        return this.query.page;
      },
      set: function (value) {
        this.query = {
          ...this.query,
          page: value,
        };
        this.$emit("reload");
      },
    },
  },
  methods: {
    setPage(page) {
      //NOTE: This function is called from the outside
      this.query.page = page;
    },
    previewItem(event) {
      this.$emit("preview", event);
    },
  },
};
</script>

<style lang="scss">
.text--capitalize {
  text-transform: capitalize;
}

.delete--hover {
  &:hover {
    color: red;
  }
}

.preview--hover {
  &:hover {
    color: --secondary;
  }
}

.edit--hover {
  &:hover {
    color: --primary;
  }
}
.copy--hover {
  &:hover {
    color: --primary;
  }
}
</style>
